import React from 'react';
import { Layout, Menu, message, Button } from 'antd';
import { MenuOutlined, LogoutOutlined, FileTextOutlined, BookOutlined, UserOutlined, ToolOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import './MainLayout.css';

const { Header, Sider, Content } = Layout;
const rootSubmenuKeys = ['lytech', 'measure-navi', 'shinozuka'];

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = React.useState(false);
  const [openKeys, setOpenKeys] = React.useState(() => getOpenKeys(location.pathname));

  function getSelectedKey(pathname) {
    if (pathname.startsWith('/measure-news')) {
      return '/measure-news';
    }
    if (pathname.startsWith('/blogs')) {
      return '/blogs';
    }
    if (pathname.startsWith('/personals')) {
      return '/personals';
    }
    if (pathname.startsWith('/news')) {
      return '/news';
    }
    return '';
  }

  function getOpenKeys(pathname) {
    if (pathname.startsWith('/measure-news')) {
      return ['measure-navi'];
    }
    if (pathname.startsWith('/blogs') || pathname.startsWith('/news')) {
      return ['lytech'];
    }
    if (pathname.startsWith('/personals')) {
      return ['shinozuka'];
    }
    return [];
  }

  React.useEffect(() => {
    setOpenKeys(getOpenKeys(location.pathname));
  }, [location.pathname]);

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      localStorage.removeItem('token');
      message.success('ログアウトしました', 2); // 2秒后自动消失
      navigate('/login');
    } else if (key.startsWith('/')) {
      navigate(key);
    }
  };

  const menuItems = [
    {
      key: 'lytech',
      icon: <FileTextOutlined />,
      label: 'LYTech',
      children: [
        {
          key: '/news',
          icon: <FileTextOutlined />,
          label: 'ニュース',
        },
        {
          key: '/blogs',
          icon: <BookOutlined />,
          label: 'ブログ',
        },
      ],
    },
    {
      key: 'measure-navi',
      icon: <ToolOutlined />,
      label: 'MeasureNavi',
      children: [
        {
          key: '/measure-news',
          icon: <FileTextOutlined />,
          label: 'ブログ',
        },
      ],
    },
    {
      key: 'shinozuka',
      icon: <UserOutlined />,
      label: 'SHINOZUKA',
      children: [
        {
          key: '/personals',
          icon: <FileTextOutlined />,
          label: 'ニュース',
        },
      ],
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'ログアウト',
    },
  ];

  const selectedKey = getSelectedKey(location.pathname);
  const handleExpandAll = () => {
    if (collapsed) {
      setCollapsed(false);
    }
    setOpenKeys(rootSubmenuKeys);
  };

  const handleCollapseAll = () => {
    setOpenKeys([]);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        collapsible 
        collapsed={collapsed} 
        onCollapse={setCollapsed}
        width={200}
      >
        <div className="logo">
          {collapsed ? '管理' : 'コンテンツ管理'}
        </div>
        {!collapsed && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '0 16px 12px' }}>
            <Button size="small" onClick={handleExpandAll}>
              全て展開
            </Button>
            <Button size="small" onClick={handleCollapseAll}>
              全て閉じる
            </Button>
          </div>
        )}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey ? [selectedKey] : []}
          openKeys={collapsed ? [] : openKeys}
          onOpenChange={(keys) => setOpenKeys(keys)}
          onClick={handleMenuClick}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header className="site-layout-header">
          <MenuOutlined 
            className="trigger"
            onClick={() => setCollapsed(!collapsed)}
          />
        </Header>
        <Content className="site-layout-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
